import { BaseFeature, FeatureType } from '@core/shared/feature';
export class StatisticsBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@common/statistics/feature","featureId":"common-statistics"},
      abilityActions: false,
      plugins: [
      // {forPlatform:'frontend', type:FeatureType.Permanent, pluginClassName:'StatisticsFrontendAdminFeature'},
      {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'StatisticsFrontendAdminFeature'
      }]
    };
  }
  getSharedDefinition() {
    return {};
  }
}